// extracted by mini-css-extract-plugin
module.exports = {"modal-container":"shareModal_modal-container__3Twrk","modal":"shareModal_modal__1k77F","close-btn":"shareModal_close-btn__23jTd"};